import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import ToolKit from '@core/components/tool-kit/ToolKit.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(ToolKit.name, ToolKit)
